import Image from "next/image";
import Container from "./Container";
import {useState} from "react";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import SvgArrowLeft from "../svg/SvgArrowLeft";
import SvgArrowRight from "../svg/SvgArrowRight";
import Title from "./Title";
import Typo from "./Typo";
import SvgCarouselBg from "../svg/SvgCarouselBg";
import iconCircle from '../public/img/icons/circle_white.png';

let carouselTimeout;

export default function ConceptCarousel({items, children}) {
    const {locale} = useRouter();
    const {common: lang} = localized[locale];

    const [active, setActive] = useState(0);
    const [isChanging, setIsChanging] = useState(false);

    const handleClickNext = () => {
        if (!isChanging) {
            (active + 1 < items.length) ? setActive(active + 1) : setActive(0);
            handleChangeSlide('right');
        }
    };

    const handleClickPrev = () => {
        if (!isChanging) {
            (active - 1 >= 0) ? setActive(active - 1) : setActive(items.length - 1);
            handleChangeSlide('left');
        }
    };

    const handleChangeSlide = (dir = 'right') => {
        clearTimeout(carouselTimeout);
        setIsChanging(dir);
        carouselTimeout = setTimeout(() => {
            setIsChanging(false);
        }, 800);
    }

    return (
        <div className="relative text-center py-16 md:py-20 overflow-x-hidden">
            <SvgCarouselBg className="overlay"/>

            <Container className="relative flex flex-col gap-20 items-center">
                {children}
                <section className="flex flex-col gap-8 w-full">
                    <header className="flex items-center gap-4 sm:gap-10 md:gap-24 justify-center">
                        <button
                            className="inline-flex items-center justify-center w-16 h-16 text-0 rounded-lg mouse-hover:text-black mouse-hover:bg-white transition-colors duration-300"
                            onClick={handleClickPrev}
                            aria-label={lang.previous}
                        >
                            <SvgArrowLeft width={25} id="concept-carousel"/>
                            {lang.previous}
                        </button>

                        <div
                            className="relative w-24 h-24 inline-flex items-center justify-center text-2xl font-bold rounded-full">
                            <div
                                className={`absolute w-full h-full top-0 left-0 pointer-events-none ${!!isChanging ? 'rotating-circle-' + isChanging : ''}`}>
                                <Image src={iconCircle}
                                       alt=""
                                       sizes="96px"
                                />
                            </div>
                            {active + 1}
                        </div>

                        <button
                            className="inline-flex items-center justify-center w-16 h-16 text-0 rounded-lg mouse-hover:text-black mouse-hover:bg-white transition-colors duration-300"
                            onClick={handleClickNext}
                            aria-label={lang.next}
                        >
                            <SvgArrowRight width={25} id="concept-carousel"/>
                            {lang.next}
                        </button>
                    </header>
                    <div className="min-h-carousel-big md:min-h-carousel">
                        <div className={`flex flex-col gap-6 will-change-transform ${!!isChanging ? 'fade-in' : ''}`}>
                            <Title Elem="h3">{items[active].title}</Title>
                            <Typo className="max-w-xl mx-auto">{items[active].body}</Typo>
                        </div>
                    </div>
                </section>
            </Container>
        </div>
    )
}
